/**
 * Project Enums
 *
 * Schemas for project categories, statuses, and sort options.
 */
import { z } from "zod";

/** Project category values */
export const PROJECT_CATEGORIES = [
	"residential",
	"commercial",
	"hospitality",
] as const;

/** Project category schema */
export const projectCategorySchema = z.enum(PROJECT_CATEGORIES);
export type ProjectCategory = z.infer<typeof projectCategorySchema>;

/** Project status values */
export const PROJECT_STATUSES = ["draft", "published", "archived"] as const;

/** Project status schema */
export const projectStatusSchema = z.enum(PROJECT_STATUSES);
export type ProjectStatus = z.infer<typeof projectStatusSchema>;

/** Project sort options */
export const PROJECT_SORT_OPTIONS = [
	"newest",
	"oldest",
	"a-z",
	"z-a",
	"featured",
] as const;

/** Project sort schema */
export const projectSortSchema = z.enum(PROJECT_SORT_OPTIONS).default("newest");
export type ProjectSort = z.infer<typeof projectSortSchema>;

/** Project type values (for enum schema) */
export const PROJECT_TYPES = [
	"residential",
	"commercial",
	"hospitality",
	"consultation",
] as const;

/** Project type schema (extended for contact form) */
export const projectTypeSchema = z.enum(PROJECT_TYPES);
export type ProjectType = z.infer<typeof projectTypeSchema>;

/** Project type options (for form dropdowns with labels) */
export const PROJECT_TYPE_OPTIONS = [
	{ value: "residential", label: "Residential" },
	{ value: "commercial", label: "Commercial" },
	{ value: "hospitality", label: "Hospitality" },
	{ value: "consultation", label: "Consultation" },
] as const;
